import { useState } from "react";
import Box from "../../components/Box";
import MainLayout from "../../components/layouts/MainLayout";
import { useControlPermission } from "../../utils/ActionPermissionUtils";
import { useFramedPoolListHooks } from "../../utils/infrastructure/FramedPoolUtils";
import AlertBox from "../../components/AlertBox";
import Pagination from "../../components/Pagination";
import ModalCreateFramedPool from "./../../components/infrastrucure/framedpool/ModalCreateFramedPool";
import ModalUpdateFramedPool from "./../../components/infrastrucure/framedpool/ModalUpdateFramedPool";
import ModalDeleteFramedPool from "./../../components/infrastrucure/framedpool/ModalDeleteFramedPool";

export default function ManageFramePoolPage() {
  const { hasAccess } = useControlPermission();
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });

  const [formFilter, setFormFilter] = useState({ q: "" });
  const [filter, setFilter] = useState({ q: "", page: 1, page_size: 10 });

  const [selectedId, setSelectedId] = useState("");
  const [modal, setModal] = useState("");

  const { data: framedPools, meta, loading, errorMsg } = useFramedPoolListHooks({ filter });

  const applyFilter = () => {
    const form_filter = { ...filter, ...formFilter, page: 1 };
    setFilter(form_filter);
  };

  const resetFilter = () => {
    setFormFilter({ q: "" });
    setFilter({ q: "", page: 1, page_size: 10 });
  };

  const onSuccess = (message) => {
    setAlert({ show: true, message, type: "success" });
    setFilter({ ...filter });
  };

  const gotoPage = (page) => {
    setFilter({ ...filter, page: page });
  };

  const handleModalClose = () => {
    setModal("");
  };

  const handleModalOpen = (type) => {
    setModal(type);
  };

  return (
    <MainLayout resource_key="setup-modem">
      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col">
            <h1 className="h3 mb-0 text-gray-800">Framed Pool</h1>
          </div>
          {hasAccess("view-framed-pool") ? (
            <div className="col-auto">
              <button className="btn btn-primary" onClick={() => handleModalOpen("create")}>
                <i className="fa fa-plus"></i> Tambah Framed Pool
              </button>
            </div>
          ) : null}
        </div>

        <Box title="Framed Pool List" loading={loading}>
          <div className="row">
            <div className="col-lg-2 col-12">
              <div className="form-group">
                <label>Pencarian</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Framed Pools"
                  value={formFilter.q}
                  onChange={(event) => setFormFilter({ ...formFilter, q: event.target.value })}
                />
              </div>
            </div>
            <div className="col-auto">
              <button
                className="btn btn-primary"
                onClick={() => applyFilter()}
                style={{ marginTop: "32px" }}
              >
                Filter
              </button>
              <button
                className="btn btn-default"
                onClick={() => resetFilter()}
                style={{ marginTop: "32px" }}
              >
                Reset
              </button>
            </div>
          </div>
          {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
          <AlertBox {...alert} setAlert={setAlert} />
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th></th>
                <th>Framed Pool</th>
              </tr>
            </thead>
            <tbody>
              {framedPools.length === 0 ? (
                <tr>
                  <td colSpan={2} className="text-center">
                    Tidak ada data
                  </td>
                </tr>
              ) : null}
              {framedPools.map((pool) => (
                <tr key={pool.id}>
                  <td style={{ width: "120px" }}>
                    <div className="d-flex" style={{ gap: "8px" }}>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => {
                          setSelectedId(pool.id);
                          handleModalOpen("update");
                        }}
                      >
                        <i className="fa fa-pencil"></i>
                      </button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => {
                          setSelectedId(pool.id);
                          handleModalOpen("delete");
                        }}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </div>
                  </td>
                  <td>{pool.name}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {meta.count > meta.page_size && (
            <Pagination
              totalpage={Math.ceil(meta.count / meta.page_size)}
              selectedpage={meta.page}
              clickpage={(page) => gotoPage(page)}
              next={() => gotoPage(meta.page + 1)}
              prev={() => gotoPage(meta.page - 1)}
            />
          )}
        </Box>
      </div>
      {/* Modals */}
      <ModalCreateFramedPool
        show={modal === "create"}
        onClose={handleModalClose}
        onSuccess={onSuccess}
      />
      <ModalUpdateFramedPool
        show={modal === "update"}
        id={modal === "update" ? selectedId : null}
        onClose={handleModalClose}
        onSuccess={onSuccess}
      />
      <ModalDeleteFramedPool
        show={modal === "delete"}
        id={modal === "delete" ? selectedId : null}
        onClose={handleModalClose}
        onSuccess={onSuccess}
      />
    </MainLayout>
  );
}
